import { gql } from '@apollo/client';

export default gql`
  query getVoucherNotes($voucherAlias: String!) {
    getVoucherNotes(voucherAlias: $voucherAlias) {
      id
      createdBy
      createdAt
      content
    }
  }
`;
